import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import { alpha, useTheme } from '@material-ui/core/styles';

const BonificacionSection = ({ section = {} }) => {
  const theme = useTheme();
  const items = Array.isArray(section.items) ? section.items : [];

  if (!section.title && items.length === 0) return null;

  return (
    <Box py={{ xs: 4, md: 5 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="secondary"
        align="center"
      >
        {section.overline || 'Bonificación'}
      </Typography>
      <Typography variant="h4" align="center" sx={{ fontWeight: 800, mb: 1 }}>
        {section.title}
      </Typography>
      {section.description && (
        <Typography align="center" color="textSecondary" sx={{ maxWidth: 720, mx: 'auto', mb: 3 }}>
          {section.description}
        </Typography>
      )}
      <Card
        elevation={3}
        sx={{
          maxWidth: 720,
          mx: 'auto',
          border: `1px solid ${alpha(theme.palette.primary.main, 0.35)}`,
          bgcolor: alpha(theme.palette.primary.main, 0.04),
        }}
      >
        <CardContent>
          {section.badge && (
            <Chip label={section.badge} color="primary" size="small" sx={{ mb: 2, fontWeight: 600 }} />
          )}
          {section.highlight && (
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', mb: 2 }}>
              {section.highlight}
            </Typography>
          )}
          {items.length > 0 && (
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
              {items.map((item, i) => (
                <Box component="li" key={i} sx={{ mb: 1 }}>
                  <Typography variant="body1" color="textSecondary">
                    {typeof item === 'string' ? item : item.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
          {section.investment && (
            <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 700 }}>
              Valor referencial: {section.investment}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

BonificacionSection.propTypes = {
  section: PropTypes.object,
};

export default BonificacionSection;
